import {
  Analytics,
  Awards,
  ConceptPlan,
  ContinuousImprovement,
  Creative,
  CrossPlatform,
  Custom,
  Delivery,
  DesigningForPatients,
  DesigningImpactfulBranding,
  EffectiveCommunication,
  EngagementTools,
  EngagingPatients,
  EventAudioVisual,
  FullyManaged,
  Gift,
  GreatContent,
  Guest,
  Impact,
  KolRehearsal,
  MaximiseReach,
  Merch,
  OnlinePlatform,
  PerfectVenue,
  Plan,
  PostPlan,
  Privacy,
  ProjectManagement,
  RelevantContent,
  Secure,
  ShareVideo,
  Sharing,
  Speaker,
  TeamBuilding,
  TechnicalInfrastructure,
  Timeline,
  Unified,
  Launch,
  Ongoing,
  Questionnaire,
  Handover,
  Development,
  Design,
  Copy,
  Brainstorm,
  Strategy,
  Search,
  Responsive,
  Accessibility,
  Web,
  Med,
  Sitemap,
  MobileDesign,
  ELearning,
  Corporate,
  BrandGuidelines,
  PositionVoice,
  Booth,
  Copywriting,
  DesignStructure,
  Dielines,
  DetailAid,
  EmailMarketing,
  Engagement,
  Information,
  Journal,
  Kol,
  Live,
  Materials,
  MedRegs,
  Merchandise,
  OfficeMaterials,
  Omnichannel,
  Portal,
  PrintProduction,
  PrintSupport,
  Signage,
  StoryTelling,
  Touch,
  VideoProduction,
  Virtual,
  VisualIdentity,
  PaidMedia,
  AppDevelopment
} from './index.jsx';

const SVGMapper = {
  'analytics': Analytics,
  'awards': Awards,
  'concept-plan': ConceptPlan,
  'continuous-improvement': ContinuousImprovement,
  'creative': Creative,
  'cross-platform': CrossPlatform,
  'custom': Custom,
  'delivery': Delivery,
  'designing-for-patients': DesigningForPatients,
  'designing-impactful-branding': DesigningImpactfulBranding,
  'effective-communication': EffectiveCommunication,
  'engagement-tools': EngagementTools,
  'engaging-patients': EngagingPatients,
  'event-audio-visual': EventAudioVisual,
  'fully-managed': FullyManaged,
  'gift': Gift,
  'great-content': GreatContent,
  'guest': Guest,
  'impact': Impact,
  'kol-rehearsal': KolRehearsal,
  'maximise-reach': MaximiseReach,
  'merch': Merch,
  'online-platform': OnlinePlatform,
  'perfect-venue': PerfectVenue,
  'plan': Plan,
  'post-plan': PostPlan,
  'privacy': Privacy,
  'project-management': ProjectManagement,
  'relevant-content': RelevantContent,
  'secure': Secure,
  'share-video': ShareVideo,
  'sharing': Sharing,
  'speaker': Speaker,
  'team-building': TeamBuilding,
  'technical-infrastructure': TechnicalInfrastructure,
  'timeline': Timeline,
  'unified': Unified,
  'launch': Launch,
  'ongoing': Ongoing,
  'questionnaire': Questionnaire,
  'handover': Handover,
  'development': Development,
  'design': Design,
  'copy': Copy,
  'brainstorm': Brainstorm,
  'strategy': Strategy,
  'search': Search,
  'responsive': Responsive,
  'accessibility': Accessibility,
  'web': Web,
  'med': Med,
  'sitemap': Sitemap,
  'mobile-design': MobileDesign,
  'e-learning': ELearning,
  'corporate': Corporate,
  'brand-guidelines': BrandGuidelines,
  'position-voice': PositionVoice,
  'booth': Booth,
  'copywriting': Copywriting,
  'design-structure': DesignStructure,
  'dielines': Dielines,
  'detail-aid': DetailAid,
  'email-marketing': EmailMarketing,
  'engagement': Engagement,
  'information': Information,
  'journal': Journal,
  'kol': Kol,
  'live': Live,
  'materials': Materials,
  'med-regs': MedRegs,
  'merchandise': Merchandise,
  'office-materials': OfficeMaterials,
  'omnichannel': Omnichannel,
  'portal': Portal,
  'print-production': PrintProduction,
  'print-support': PrintSupport,
  'signage': Signage,
  'story-telling': StoryTelling,
  'touch': Touch,
  'video-production': VideoProduction,
  'virtual': Virtual,
  'visual-identity': VisualIdentity,
  'paid-media': PaidMedia,
  'app-development': AppDevelopment
};

export default SVGMapper;
